import { defineContract } from "../defineContract";
import { SOCKET_EVENTS } from "../socketEvents";

/**
 * Shape mínimo que os consumidores atuais usam (TransferTicketModalCustom,
 * ScheduleModal, CampaignModal, ChatBots/options). O model Queue no backend
 * tem bem mais colunas (greetingMessage, schedules, integrações...) — não
 * duplicamos aqui até um consumidor precisar, pra não este arquivo virar
 * espelho do model e apodrecer sozinho.
 */
export interface QueueDTO {
  id: number;
  name: string;
  color: string;
  companyId: number;
  orderQueue: number | null;
}

/**
 * Payload de SOCKET_EVENTS.QUEUE.LIST — o que QueueController.store/update/
 * remove emitem hoje. `store` e `update` emitem "update" (não "create" —
 * o front trata "create" como sinônimo de "update" na prática, mas o
 * backend nunca manda essa action; tipado pelo que É emitido).
 */
export type QueueEventPayload =
  | { action: "update"; queue: QueueDTO }
  | { action: "delete"; queueId: number };

export const queueContract = defineContract<void, QueueDTO[], QueueEventPayload>({
  route: "/queue",
  method: "GET",
  events: { changed: SOCKET_EVENTS.QUEUE.LIST },
  cache: { ttl: 10 * 60 * 1000, invalidatedBy: ["changed"] }
});
